<div
  class="mx-auto mt-8 max-w-5xl border border-slate-200 bg-white p-6 shadow-sm sm:px-8"
>
  <h4 class="text-2xl font-bold text-slate-900">
    Internal Server Error - refreshing the page will make the exception
    disappear
  </h4>

  <ng-container *ngIf="error">
    <h5 class="mt-6 text-lg font-semibold text-red-600">
      Error: {{ error.message }}
    </h5>
    <p class="mt-3 font-semibold text-slate-700">
      Note: if you are seeing this then Angular is probably not responsible
    </p>
    <p class="mt-4 text-slate-700">What to do next?</p>
    <ol class="mt-3 list-decimal space-y-2 pl-6 text-slate-700">
      <li>Open chrome dev tools</li>
      <li>Inspect the network tab</li>
      <li>Check the failing request</li>
      <li>Examine this request URL - make sure this is correct</li>
      <li>
        Reproduce the error in postman - if we get the same response in Postman,
        then the issue is NOT with Angular
      </li>
    </ol>
    <p class="mt-6 text-slate-700">
      Following is the stack trace - this is where your investigation should
      start!
    </p>
    <pre
      class="mt-4 overflow-x-auto rounded-2xl bg-slate-100 p-4 text-sm text-slate-700"
      >{{ error.details }}</pre
    >
  </ng-container>
</div>
